export const buildPropertyKey = (params: { mlsSource?: string; mlsId?: string }) => {
  return `${params.mlsSource}:${params.mlsId}`;
};
